import { Attivita } from "./CotEsitoUvm";

export class SceltaPdeStrutturaBodyReq {
    richiestaId: number | undefined;
    strutturaId: number | undefined;
    operatoreId: number | null | undefined;
    codiceQualificaOperatore: string | undefined;
    frequenza: string | undefined;
    tipoInterventoId: number | null | undefined;
    attivita: Attivita[] | undefined;
    dataInizio : Date | undefined;
    dataFine : Date | undefined;
    noteAggiuntive: string | undefined;
}